import React from 'react';
import {
  LAST_ATTRIBUTED_TOUCH_DATA_TILDE_ADVERTISING_PARTNER_NAME,
  LAST_ATTRIBUTED_TOUCH_DATA_TILDE_FEATURE,
  LAST_ATTRIBUTED_TOUCH_TYPE,
  LOCAL_CURRENCY,
  SUBTYPE,
} from '../../../../../shared/constants/cenariusDimensions';
import { DEFAULT_DRUID_FILTERS_LIST } from '../../../../../shared/constants/defaultDruidDimensions';
import { ALL_EVENT_NAMES_WITH_LOCAL_CURRENCY, DATASOURCES } from '../../../common/support/eo_mapping';
import { CALCULATED_EVENT_NAMES_WITH_LOCAL_CURRENCY } from '../../../common/support/eo_mapping/event_names';
import InFilter from '../../../common/support/utils/druid/filters/InFilter';
import type { TabConfig } from '../../components/nav/neoTabsConfig';
import AdsUnifiedTab from './AdsUnifiedTab';

export const ADS_PAGE_TITLE = 'Analytics';

export const ADS_TOP_NAV_TABS: TabConfig[] = [
  {
    id: 'mui-tab-ads-unified',
    route: '/ads/analytics/unified',
    label: <AdsUnifiedTab />,
  },
  {
    id: 'mui-tab-ads-event-level',
    route: '/ads/analytics/activity',
    label: 'Activity',
  },
  {
    id: 'mui-tab-ads-skadnetwork',
    route: '/ads/analytics/skadnetwork',
    label: 'SKAdNetwork',
  },
  {
    id: 'mui-tab-ads-cohorts',
    route: '/ads/analytics/cohorts',
    label: 'Cohorts',
  },
];

export const ADS_COMPARE_BY_DIMENSIONS = [...DEFAULT_DRUID_FILTERS_LIST, LOCAL_CURRENCY, SUBTYPE];

export const ADS_EVENT_LIST = Object.keys(ALL_EVENT_NAMES_WITH_LOCAL_CURRENCY)
  .concat(Object.keys(CALCULATED_EVENT_NAMES_WITH_LOCAL_CURRENCY))
  .filter((e) => e !== 'PAGEVIEW' && e !== 'BRANCH_CTA_VIEW' && e !== 'JOURNEYS_DISMISSAL');

export const REQUIRED_FILTER = new InFilter(LAST_ATTRIBUTED_TOUCH_DATA_TILDE_FEATURE, ['paid advertising']);

export const DEFAULT_DIMENSIONS = [LAST_ATTRIBUTED_TOUCH_DATA_TILDE_ADVERTISING_PARTNER_NAME];

export const DEFAULT_FILTER = new InFilter(LAST_ATTRIBUTED_TOUCH_TYPE, ['CLICK']);

export const DATA_SOURCES = Object.keys(DATASOURCES);

export const MULTI_CONNECTION_AD_PARTNERS = ['google_ads'];
